import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../../shared/services/alert.service';
import {AdminService} from '../../../shared/services/admin.service';

@Component({
    selector: 'app-add-sub-admin',
    templateUrl: './add-sub-admin.component.html',
    styleUrls: ['./add-sub-admin.component.scss']
})
export class AddSubAdminComponent implements OnInit {
    addSubAdminForm: FormGroup;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;

    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;


    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                private adminService: AdminService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-sub-admin').toggleOpen();
    }

    refresh() {
        this.addSubAdminForm = this.fb.group({
            'name': ['', Validators.required],
            'username': ['', Validators.required],
            'email': ['', Validators.compose([Validators.required, Validators.pattern('^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
            'contact': ['', Validators.compose([Validators.required, Validators.pattern('^[5-9]{1}[0-9]{9}$')])],
            'password': ['', (!this.data || !this.data['id']) ? Validators.required : '']
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addSubAdminForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
            'username': (this.data && this.data['username']) ? this.data['username'] : '',
            'email': (this.data && this.data['email']) ? this.data['email'] : '',
            'contact': (this.data && this.data['contact']) ? this.data['contact'] : ''
        });
    }


    submit() {
        this.submitted = true;
        if (!this.addSubAdminForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addSubAdminForm.value && this.addSubAdminForm.value.name) ? this.addSubAdminForm.value.name : '',
                'username': (this.addSubAdminForm.value && this.addSubAdminForm.value.username) ? this.addSubAdminForm.value.username : '',
                'email': (this.addSubAdminForm.value && this.addSubAdminForm.value.email) ? this.addSubAdminForm.value.email : '',
                'contact': (this.addSubAdminForm.value && this.addSubAdminForm.value.contact) ? this.addSubAdminForm.value.contact : '',
                'password': (this.addSubAdminForm.value && this.addSubAdminForm.value.password) ? this.addSubAdminForm.value.password : ''
            };
            this.submitting = true;
            this.adminService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addSubAdminForm.reset();
                    this.addSubAdminForm.patchValue({
                        'name': '',
                        'username': '',
                        'email': '',
                        'contact': '',
                        'password': ''
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addSubAdminForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addSubAdminForm.value && this.addSubAdminForm.value.name) ? this.addSubAdminForm.value.name : '',
                'username': (this.addSubAdminForm.value && this.addSubAdminForm.value.username) ? this.addSubAdminForm.value.username : '',
                'email': (this.addSubAdminForm.value && this.addSubAdminForm.value.email) ? this.addSubAdminForm.value.email : '',
                'contact': (this.addSubAdminForm.value && this.addSubAdminForm.value.contact) ? this.addSubAdminForm.value.contact : ''
            };
            this.submitting = true;
            this.adminService.update(this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }

}
